import LocalizedStrings from "react-localization";

import { type EnumsStrings, enumsEn, enumsEs } from "./enums";
import { createStringFormatters } from "./formatters";
import { type MobileStrings, mobileStringsEn, mobileStringsEs } from "./mobile";
import { type PortalStrings, portalStringsEn, portalStringsEs } from "./portal";
import { type SharedStrings, sharedStringsEn, sharedStringsEs } from "./shared";
import { type TasksStrings, tasksStringsEn, tasksStringsEs } from "./tasks";
import { type UiComponents, UiComponentsEn, UiComponentsEs } from "./ui-components";

interface RemiStrings {
  portal: PortalStrings;
  tasks: TasksStrings;
  ui_components: UiComponents;
  enums: EnumsStrings;
  mobile: MobileStrings;
  shared: SharedStrings;
}

export const strings = new LocalizedStrings<RemiStrings>({
  en: {
    portal: portalStringsEn,
    tasks: tasksStringsEn,
    ui_components: UiComponentsEn,
    enums: enumsEn,
    mobile: mobileStringsEn,
    shared: sharedStringsEn,
  },
  es: {
    portal: portalStringsEs,
    tasks: tasksStringsEs,
    ui_components: UiComponentsEs,
    enums: enumsEs,
    mobile: mobileStringsEs,
    shared: sharedStringsEs,
  },
});

export const { formatString } = createStringFormatters(strings);
